import {Injectable} from '@angular/core';
import {ParametroPortalService} from '../../../services/parametro-portal.service';
import {isNullOrUndefined} from 'util';
import {ParametrosOcultoEnum, ParametrosPortalEnum} from '../../../enums/parametros.enum';

@Injectable({
  providedIn: 'root'
})
export class ParamEspecificoLocalStorageService {


  constructor(
    private parametroPortalService: ParametroPortalService,
  ) {
  }


  async getParametroEspecificoLocalStorage(parametroNome: string) {
    const param = sessionStorage.getItem(parametroNome);
    if (param) {
      return param;
    }

    const parametros = await this.parametroPortalService.obterListaParametros(
      [parametroNome]).toPromise();
    if (isNullOrUndefined(parametros) || parametros.length === 0) {
      return null;
    }
    sessionStorage.setItem(parametroNome, parametros[0].valor);
    return parametros[0].valor;
  }

  async salvarParametroEspecificoLocalStorage(parametroNome: ParametrosPortalEnum | ParametrosOcultoEnum) {
    const parametro = await this.parametroPortalService.obterParametroEspecifico(
      {id: parametroNome}).toPromise();
    if (!isNullOrUndefined(parametro)) {
      sessionStorage.setItem(parametroNome, parametro.valor);
    }
  }

  async salvarListaParametroLocalStorage(parametrosNome: string[]) {

    const parametro = await this.parametroPortalService.obterListaParametros(
      parametrosNome).toPromise();

    parametro.forEach(param => {
      sessionStorage.setItem(param.id, param.valor);
    });
  }


  async atualizarParametroEspecificoLocalStorage(...parametroNome: string[]) {
    const parametros = await this.parametroPortalService.obterListaParametros(
      parametroNome).toPromise();

    if (parametros == null || parametros.length === 0) {
      return;
    }
    parametroNome.forEach(paramNome => {
      const param = parametros.find(p => p.id === paramNome);
      if (param) {
        sessionStorage.setItem(paramNome, param.valor);
      }
    });
  }

}


